@switch (layoutService.layout$ | async) {
    @case (PageLayout.Blank) {
        <router-outlet />
    }
    @case (PageLayout.Default) {
        <app-layout-admin-default>
            <router-outlet />
        </app-layout-admin-default>
    }
    @case (PageLayout.Client) {
        <app-layout-client>
            <router-outlet />
        </app-layout-client>
    }
    @case (PageLayout.ClientDashboard) {
        <app-layout-client-dashboard>
            <router-outlet />
        </app-layout-client-dashboard>
    }
    @case (PageLayout.Vendor) {
        <app-layout-vendor>
            <router-outlet />
        </app-layout-vendor>
    }
    @default {
        <router-outlet />
    }
}
<hlm-toaster />
